import Head from "next/head";
import ProgramCard from "../../components/program/ProgramCard";
import { getPrograms } from "../../service/beranda/useDataProgram";

export async function getServerSideProps(context) {
  const programs = await getPrograms();
  const name = programs.map((item) => {
    return item.name;
  });

  return {
    props: { data: programs, name: name },
  };
}

export default function Index({ data, name }) {
  const schemeData = {
    "@type": "Program",
    data: data,
  };

  return (
    <main className="mx-auto flex h-full w-full max-w-[1280px] flex-col gap-5 px-4 pt-24 pb-10 md:pt-36">
      <Head>
        <title>Program | Wardaya Online by Wardaya College</title>
        <meta
          name="description"
          content={
            "Halaman ini berisi semua program yang ada di Wardaya College seperti : " +
            name.toString().toLowerCase()
          }
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemeData),
          }}
        />
      </Head>
      <div className="rounded-lg py-6 px-8 shadow-md">
        <h1 className="font-nunito text-2xl font-bold capitalize">
          Program Kelas Wardaya College
        </h1>
        <p className="font-nunito text-lg">
          Halaman ini berisi semua program yang ada di Wardaya College
        </p>
      </div>

      <div className="flex flex-col gap-5 md:flex-row">
        <div className="w-full">
          <ul className="grid grid-cols-2 gap-5 md:grid-cols-2 lg:grid-cols-3">
            {data.map((item) => (
              <ProgramCard
                key={item.id}
                name={item.name}
                desc={item.description}
                img={item.image}
              />
            ))}
          </ul>
        </div>
      </div>
    </main>
  );
}
